// extracted by mini-css-extract-plugin
export var messageSideLeft = "_gz-1";
export var messageSideRight = "_gz-2";
export var orderLookupBubbleContainer = "_gz-0";
export var submitButton = "_gz-3";